const PRODUCTION_HOST_ENV = 'production'
const currentEnv = process.env.HOST_ENV ?? PRODUCTION_HOST_ENV

export const getDomainUrl = () => {
  // console.log("process.env----", process.env)
  console.info('currentEnv', currentEnv)
  const urls = {
    development: 'https://dev.indmoney.com',
    beta: 'https://beta.indmoney.com',
    beta1: 'https://beta1.indmoney.com',
    production: 'https://www.indmoney.com',
  }
  return urls[currentEnv] ?? urls[PRODUCTION_HOST_ENV]
}
export const getINDStockDomainUrl = () => {
  const urls = {
    development: 'https://dev.indmoney.com',
    beta: 'https://beta.indstocks.com',
    beta1: 'https://beta1.indstocks.com',
    production: 'https://www.indstocks.com',
  }
  return urls[currentEnv] ?? urls[PRODUCTION_HOST_ENV]
}

export const getHostName = () => {
  const urls = {
    development: 'dev.indmoney.com',
    beta: 'beta.indmoney.com',
    beta1: 'beta1.indmoney.com',
    production: 'www.indmoney.com',
  }
  return urls[currentEnv] ?? urls[PRODUCTION_HOST_ENV]
}

export const getINDStocksHostName = () => {
  const urls = {
    development: 'dev.indstocks.com',
    beta: 'beta.indstocks.com',
    beta1: 'beta1.indstocks.com',
    production: 'www.indstocks.com',
  }
  return urls[currentEnv] ?? urls[PRODUCTION_HOST_ENV]
}

export const getMfServiceUrl = () => {
  const urls = {
    production: 'https://apixt-iw.indmoney.com/mf-tracking-ext',
    beta: 'https://apixt-iw.indmoney.com/mf-tracking-ext',
    beta1: 'https://apixt-iw.indmoney.com/mf-tracking-ext',
    development: 'https://mf-tracking-pp.indiawealth.in/public',
    // development: 'https://kong-proxy-pp.indiawealth.in/ind-mftracking',
  }
  return urls[currentEnv] ?? urls[PRODUCTION_HOST_ENV]
}

export const getMfTrackingServiceUrl = () => {
  const urls = {
    production: 'https://mf-tracking.indiawealth.in',
    beta: 'https://mf-tracking-pp.indiawealth.in',
    beta1: 'https://mf-tracking.indiawealth.in',
    development: 'https://mf-tracking-pp.indiawealth.in',
  }
  return urls[currentEnv] ?? urls[PRODUCTION_HOST_ENV]
}

export const getMfExtServiceUrl = () => {
  const urls = {
    production: 'https://apixt-iw.indmoney.com/mf-ext',
    beta: 'https://kong-proxy-pp.indiawealth.in/ind-mf/api/public',
    beta1: 'https://apixt-iw.indmoney.com/mf-ext',
    development: 'https://apixt-iw.indmoney.com/mf-ext',
  }
  return urls[currentEnv] ?? urls[PRODUCTION_HOST_ENV]
}

export const getSEOServiceUrl = () => {
  const urls = {
    production: 'https://apixt-iw.indmoney.com/wright/api',
    beta: 'https://apixt-iw.indmoney.com/wright/api',
    beta1: 'https://apixt-iw.indmoney.com/wright/api',
    development: 'https://apixt-iw.indmoney.com/wright/api',
  }
  return urls[currentEnv] ?? urls[PRODUCTION_HOST_ENV]
}

export const getUsStocksServiceUrl = () => {
  const urls = {
    production: 'https://us-stocks.indiawealth.in/api',
    beta: 'https://us-stocks.indiawealth.in/api',
    beta1: 'https://us-stocks.indiawealth.in/api',
    development: 'https://us-stocks.indiawealth.in/api',
  }
  return urls[currentEnv] ?? urls[PRODUCTION_HOST_ENV]
}

export const getUsStocksExtServiceUrl = () => {
  const urls = {
    production: 'https://us-stocks-ext.indiawealth.in/api',
    beta: 'https://us-stocks-ext.indiawealth.in/api',
    beta1: 'https://us-stocks-ext.indiawealth.in/api',
    development: 'https://us-stocks-ext.indiawealth.in/api',
  }
  return urls[currentEnv] ?? urls[PRODUCTION_HOST_ENV]
}

export const getOldStrapiServiceUrl = () => {
  const urls = {
    production: 'https://strapi-api.indiawealth.in',
    beta: 'https://strapi-api.indiawealth.in',
    beta1: 'https://strapi-api.indiawealth.in',
    development: 'https://strapi-api.indiawealth.in',
  }
  return urls[currentEnv] ?? urls[PRODUCTION_HOST_ENV]
}

export const getStrapi4ServiceUrl = () => {
  const urls = {
    production: 'https://strapi-apinew.indiawealth.in/api',
    beta: 'https://strapi-apinew.indiawealth.in/api',
    beta1: 'https://strapi-apinew.indiawealth.in/api',
    development: 'https://strapi-apinew.indiawealth.in/api',
  }
  return urls[currentEnv] ?? urls[PRODUCTION_HOST_ENV]
}

export const getGlobalSearchServiceUrl = () => {
  const urls = {
    production: 'https://apixt-iw.indmoney.com/global-search/public',
    beta: 'https://apixt-iw.indmoney.com/global-search/public',
    beta1: 'https://apixt-iw.indmoney.com/global-search/public',
    development: 'https://apixt-iw.indmoney.com/global-search/public',
  }
  return urls[currentEnv] ?? urls[PRODUCTION_HOST_ENV]
}

export const getFDServiceUrl = () => {
  const urls = {
    production: 'https://apixt-fz.indmoney.com/fd-ext/api',
    beta: 'https://apixt-fz.indmoney.com/fd-ext/api',
    beta1: 'https://fd-pp.indiawealth.in/api',
    development: 'https://apixt-fz.indmoney.com/fd-ext/api',
  }
  return urls[currentEnv] ?? urls[PRODUCTION_HOST_ENV]
}

export const getIndMemoryExtServiceUrl = () => {
  const urls = {
    production: 'https://apixt-iw.indmoney.com/ind-memory-ext',
    beta: 'https://apixt-iw.indmoney.com/ind-memory-ext',
    beta1: 'https://apixt-iw.indmoney.com/ind-memory-ext',
    development: 'https://apixt-iw.indmoney.com/ind-memory-ext',
  }
  return urls[currentEnv] ?? urls[PRODUCTION_HOST_ENV]
}

export const getInsuranceServiceUrl = () => {
  const urls = {
    production: 'https://apixt-fz.indmoney.com/insurance-ext/api',
    beta: 'https://kong-proxy-pp.indiawealth.in/ind-insurance/api',
    beta1: 'https://apixt-fz.indmoney.com/insurance-ext/api',
    development: 'https://apixt-fz.indmoney.com/insurance-ext/api',
  }
  return urls[currentEnv] ?? urls[PRODUCTION_HOST_ENV]
}

export const getInsuranceServiceCoreUrl = () => {
  const urls = {
    production: 'https://apixt-iw.indmoney.com/core/insurance/service/api/v1',
    beta: 'https://apixt-iw.indmoney.com/core/insurance/service/api/v1',
    beta1: 'https://apixt-iw.indmoney.com/core/insurance/service/api/v1',
    development: 'https://apixt-iw.indmoney.com/core/insurance/service/api/v1',
  }
  return urls[currentEnv] ?? urls[PRODUCTION_HOST_ENV]
}

export const getPaymentsServiceUrl = () => {
  const urls = {
    production: 'https://apixt-iw.indmoney.com/payments',
    beta: 'https://apixt-iw.indmoney.com/payments',
    beta1: 'https://apixt-iw.indmoney.com/payments',
    development: 'https://apixt-iw.indmoney.com/payments',
  }
  return urls[currentEnv] ?? urls[PRODUCTION_HOST_ENV]
}

export const getVyaparServiceUrl = () => {
  const urls = {
    production: 'https://apixt-in.indmoney.com/vyapar',
    beta: 'https://apixt-in.indmoney.com/vyapar',
    beta1: 'https://apixt-in.indmoney.com/vyapar',
    development: 'https://apixt-in.indmoney.com/vyapar',
  }
  return urls[currentEnv] ?? urls[PRODUCTION_HOST_ENV]
}

export const getSHIELD_URL = () => {
  const urls = {
    production: 'https://apixt-iw.indmoney.com/indshield',
    beta: 'https://apixt-iw.indmoney.com/indshield',
    beta1: 'https://apixt-iw.indmoney.com/indshield',
    development: 'https://kong-proxy-pp.indiawealth.in/ind-shield',
  }
  return urls[currentEnv] ?? urls[PRODUCTION_HOST_ENV]
}

export const getIndianStockBrokerUrl = () => {
  const urls = {
    production: 'https://apixt-in.indmoney.com/indian-stock-broker',
    beta: 'https://apixt-in.indmoney.com/indian-stock-broker',
    beta1: 'https://apixt-in.indmoney.com/indian-stock-broker',
    development: 'https://apixt-in.indmoney.com/indian-stock-broker',
  }
  return urls[currentEnv] ?? urls[PRODUCTION_HOST_ENV]
}

export const getWidgetServiceUrl = () => {
  const urls = {
    production: 'https://apixt-iw.indmoney.com/widget-prod',
    beta: 'https://apixt-iw.indmoney.com/widget-prod',
    beta1: 'https://apixt-iw.indmoney.com/widget-prod',
    development: 'https://apixt-iw.indmoney.com/widget-prod',
  }
  return urls[currentEnv] ?? urls[PRODUCTION_HOST_ENV]
}

export const getGoalsServiceUrl = () => {
  const urls = {
    production: 'https://apixt-iw.indmoney.com/goal',
    beta: 'https://apixt-iw.indmoney.com/goal',
    beta1: 'https://apixt-iw.indmoney.com/goal',
    development: 'https://apixt-iw.indmoney.com/goal',
  }
  return urls[currentEnv] ?? urls[PRODUCTION_HOST_ENV]
}

export const getAccountAggregatorUrl = () => {
  const urls = {
    production: 'https://apixt-iw.indmoney.com/acc-aggregator',
    beta: 'https://apixt-iw.indmoney.com/acc-aggregator',
    beta1: 'https://apixt-iw.indmoney.com/acc-aggregator',
    development: 'https://apixt-iw.indmoney.com/acc-aggregator',
  }
  return urls[currentEnv] ?? urls[PRODUCTION_HOST_ENV]
}

export const getOctopusServiceUrl = () => {
  const urls = {
    production: 'https://apixt-iw.indmoney.com/octopus',
    beta: 'https://apixt-iw.indmoney.com/octopus',
    beta1: 'https://apixt-iw.indmoney.com/octopus',
    development: 'https://apixt-iw.indmoney.com/octopus',
  }
  return urls[currentEnv] ?? urls[PRODUCTION_HOST_ENV]
}

export const getShieldServiceUrl = () => {
  const urls = {
    production: 'https://apixt-iw.indmoney.com/profilex/public',
    beta: 'https://apixt-iw.indmoney.com/profilex/public',
    beta1: 'https://apixt-iw.indmoney.com/profilex/public',
    development: 'https://apixt-iw.indmoney.com/profilex/public',
  }
  return urls[currentEnv] ?? urls[PRODUCTION_HOST_ENV]
}

export const getHyperVergeLoginUrl = () => {
  const urls = {
    production: 'https://auth.hyperverge.co/login',
    beta: 'https://auth.hyperverge.co/login',
    beta1: 'https://auth.hyperverge.co/login',
    development: 'https://auth.hyperverge.co/login',
  }
  return urls[currentEnv] ?? urls[PRODUCTION_HOST_ENV]
}

export const getVyaparBackgroundOfficeUrls = () => {
  const urls = {
    production: 'https://apixt-in.indmoney.com/vyapar-backoffice',
    beta: 'https://apixt-in.indmoney.com/vyapar-backoffice',
    beta1: 'https://apixt-in.indmoney.com/vyapar-backoffice',
    development: 'https://apixt-in.indmoney.com/vyapar-backoffice',
  }
  return urls[currentEnv] ?? urls[PRODUCTION_HOST_ENV]
}

export const getScoutServiceUrl = () => {
  const urls = {
    production: 'https://apixt-in.indmoney.com/scout/api/v1',
    beta: 'https://apixt-in-pp.indmoney.com/scout-pp/v1',
    beta1: 'https://apixt-in-pp.indmoney.com/scout-pp/v1',
    development: 'https://apixt-in-pp.indmoney.com/scout-pp/v1',
  }
  return urls[currentEnv] ?? urls[PRODUCTION_HOST_ENV]
}

export const getIndStocksBackgroundUrl = () => {
  const urls = {
    production: 'https://apixt-in.indmoney.com/isb-bg',
    beta: 'https://apixt-in.indmoney.com/isb-bg',
    beta1: 'https://apixt-in.indmoney.com/isb-bg',
    development: 'https://apixt-in.indmoney.com/isb-bg',
  }
  return urls[currentEnv] ?? urls[PRODUCTION_HOST_ENV]
}

export const getUsStocksBaseAuthUrl = () => {
  const urls = {
    production: 'https://us-stocks.indiawealth.in/auth/api',
    beta: 'https://us-stocks.indiawealth.in/auth/api',
    beta1: 'https://us-stocks.indiawealth.in/auth/api',
    development: 'https://us-stocks.indiawealth.in/auth/api',
  }
  return urls[currentEnv] ?? urls[PRODUCTION_HOST_ENV]
}

export const getUsStocksExtAuthServiceUrl = () => {
  const urls = {
    production: 'https://apixt-fz.indmoney.com/us-stocks-ext/api',
    beta: 'https://apixt-fz.indmoney.com/us-stocks-ext/api',
    beta1: 'https://apixt-fz.indmoney.com/us-stocks-ext/api',
    development: 'https://apixt-fz.indmoney.com/us-stocks-ext/api',
  }
  return urls[currentEnv] ?? urls[PRODUCTION_HOST_ENV]
}
export const getUsStocksIntUrl = () => {
  const urls = {
    production: 'https://us-stocks-int.indiawealth.in/api',
    beta: 'https://us-stocks-int.indiawealth.in/api',
    beta1: 'https://us-stocks-int.indiawealth.in/api',
    development: 'https://us-stocks-int.indiawealth.in/api',
  }
  return urls[currentEnv] ?? urls[PRODUCTION_HOST_ENV]
}

export const getSubscriptionServiceUrl = () => {
  const urls = {
    production:
      'https://subscription.indiawealth.in/api/public/v1/subscription',
    beta: 'https://subscription.indiawealth.in/api/public/v1/subscription',
    beta1: 'https://subscription.indiawealth.in/api/public/v1/subscription',
    development:
      'https://subscription.indiawealth.in/api/public/v1/subscription',
  }
  return urls[currentEnv] ?? urls[PRODUCTION_HOST_ENV]
}

export const getIndianStockCatalogUrl = () => {
  const urls = {
    production: 'https://apixt-in.indmoney.com/indian-stock-broker/catalog',
    beta: 'https://apixt-in.indmoney.com/indian-stock-broker/catalog',
    beta1: 'https://apixt-in.indmoney.com/indian-stock-broker/catalog',
    development: 'https://apixt-in.indmoney.com/indian-stock-broker/catalog',
  }
  return urls[currentEnv] ?? urls[PRODUCTION_HOST_ENV]
}

export const getIndMoneyCoreAPI = () => {
  const urls = {
    production: 'https://apixt-iw.indmoney.com/core/api',
    beta: 'https://apixt-iw.indmoney.com/core/api',
    beta1: 'https://apixt-iw.indmoney.com/core/api',
    development: 'https://apixt-iw.indmoney.com/core/api',
  }
  return urls[currentEnv] ?? urls[PRODUCTION_HOST_ENV]
}

export const getIndTrackServiceAPI = () => {
  const urls = {
    production: 'https://apixt-iw.indmoney.com/track/api',
    beta: 'https://apixt-iw.indmoney.com/track/api',
    beta1: 'https://apixt-iw.indmoney.com/track/api',
    development: 'https://apixt-iw.indmoney.com/track/api',
  }
  return urls[currentEnv] ?? urls[PRODUCTION_HOST_ENV]
}
